import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import orderBy from 'lodash/orderBy';
import isEqual from 'lodash/isEqual';

export default {
    cloneDeep,
    debounce,
    orderBy,
    isEqual,
}
